import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE } from './api/client';
import './AdminApplicationDetails.css';

const AdminApplicationDetails = () => {
    const { applicationId } = useParams(); // Extract application ID from the URL
    const navigate = useNavigate(); // Initialize navigate for navigation
    const [application, setApplication] = useState(null);
    const [navigationIds, setNavigationIds] = useState({
        previousApplicationId: null,
        nextApplicationId: null,
    });
    const [loading, setLoading] = useState(true); // Loading state

    useEffect(() => {
        const fetchApplicationDetails = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem('token');
                const authHeaders = { Authorization: `Bearer ${token}` };

                const response = await fetch(
                    `${API_BASE}/api/job/admin/application/${applicationId}`,
                    { headers: authHeaders }
                );
                if (!response.ok) {
                    throw new Error('Failed to fetch application details');
                }
                const data = await response.json();
                setApplication(data);

                const navigationResponse = await fetch(
                    `${API_BASE}/api/job/admin/application/${applicationId}/navigation`,
                    { headers: authHeaders }
                );
                if (navigationResponse.ok) {
                    const navigationData = await navigationResponse.json();
                    setNavigationIds({
                        previousApplicationId: navigationData.previousApplicationId,
                        nextApplicationId: navigationData.nextApplicationId,
                    });
                }
        
                setLoading(false);
            } catch (error) {
                console.error("Error fetching application details:", error);
                setLoading(false);
            }
        };        
        fetchApplicationDetails();
    }, [applicationId]); // Only trigger the effect when applicationId changes

    if (loading) {
        return <p>Loading...</p>; // Show loading message while data is being fetched
    }

    return (
        <div className="ApplicationDetails">
            <h2>Application Details</h2>
            <div className="application-card">
                <ul>
                    {Object.entries(application.fields).map(([key, value]) => (
                        <li key={key}>
                            <strong>{key}:</strong> {value}
                        </li>
                    ))}
                </ul>

                <p><strong>Resumes:</strong></p>
                <ul>
                    {application.files.map((file) => (
                        <li key={file.url}>
                            <a href={file.url} target="_blank" rel="noopener noreferrer">
                                {file.originalName}
                            </a>
                        </li>
                    ))}
                </ul>

                <p><strong>Submitted At:</strong> {new Date(application.submittedAt).toLocaleString()}</p>
            </div>

            <div className="navigation-buttons">
                {navigationIds.previousApplicationId ? (
                    <button
                        className="previous-button"
                        onClick={() => navigate(`/application/${navigationIds.previousApplicationId}`)}
                    >
                        ← Previous Application
                    </button>
                ) : null}

                {navigationIds.nextApplicationId ? (
                    <button
                        className="next-button"
                        onClick={() => navigate(`/application/${navigationIds.nextApplicationId}`)}
                    >
                        Next Application →
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default AdminApplicationDetails;
